import { render, staticRenderFns } from "./Notification20230410.vue?vue&type=template&id=1b48cd23&scoped=true&"
import script from "./Notification20230410.vue?vue&type=script&lang=js&"
export * from "./Notification20230410.vue?vue&type=script&lang=js&"
import style0 from "./Notification20230410.vue?vue&type=style&index=0&id=1b48cd23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b48cd23",
  null
  
)

export default component.exports